// Passed straight into navigator.geolocation.getCurrentPosition options.
// High accuracy pulls the GPS (not IP fallback) so the drawer centers on the
// user's actual position. 10s timeout is generous enough for a cold GPS fix
// on mobile, and maximumAge: 0 forces a fresh reading (no stale cache).
export const HIGH_ACCURACY_ENABLED = true;

export const TIMEOUT_MS = 10_000;

export const MAXIMUM_AGE_MS = 0;
